<template>
    <!-- bind class "edit-is-active" to navigation -->
    <div class="navbar" :class="{ 'edit-is-active': editActive }">
        <div class="btn-group" v-if="!isRouteAddMumblCard">
            <div class="btn-floating edit btn-large" v-if="isAdmin">
                <router-link :to="{ name: 'Index' }" v-if="editActive">
                    <i class="material-icons">remove_red_eye</i>
                </router-link>

                <router-link :to="{ name: 'EditMumblCard' }" v-else>
                    <i class="material-icons">edit</i>
                </router-link>
            </div>

            <div class="btn-floating add btn-large" v-if="editActive">
                <router-link :to="{ name: 'AddMumblCard' }">
                    <i class="material-icons">add</i>
                </router-link>
            </div>
        </div>
        <div class="btn-group" v-else>
            <div class="btn-floating edit btn-large" @click="backToEdit">
                <i class="material-icons">arrow_back</i>
            </div>
        </div>
        <nav class="nav-extended">
            <div class="nav-content container">
                <ul class="nav-links">
                    <!-- if user is not logged in show signup and login buttons (template is not rendered just group the li tags for the if else condition) -->
                    <template v-if="!user">
                        <li><router-link :to="{ name: 'Signup' }">Signup</router-link></li>
                        <li><router-link :to="{ name: 'Login' }">Login</router-link></li>
                    </template>
                    <!-- if user is logged in show logout button and users email adress  -->
                    <template v-else="user">
                        <li class="nav-links__user"><span>{{ user.email }}</span></li>
                        <li class="nav-links__logout"><a @click="logout">Logout</a></li>
                    </template>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
import firebase from 'firebase'

export default {
    name: 'Navbar',
    props: [
        'editActive',
        'isAdmin'
    ],
    data() {
        return {
            isRouteAddMumblCard: null,
            user: null
        }
    },
    methods: {
        backToEdit() {
            // go to the route before (from route history)
            this.$router.go(-1)
        },
        logout() {
            // logg out user
            firebase.auth().signOut()
            // when logout is completed redirect to login route
            .then(() => {
                this.$router.push({ name: 'Login' })
            })
        }
    },
    watch: {
        $route() {
            // Check on route change if given route is true, if it is then hide Nav.
            if (this.$route.path === "/add-mumblcard") {
                this.isRouteAddMumblCard = true
            } else  {
                this.isRouteAddMumblCard = false
            }
        }
    },
    created() {
        // Check after component creation (before component is visible) if given route is true, if it is then hide Nav.
        if (this.$route.path === "/add-mumblcard") {
            this.isRouteAddMumblCard = true
        } else  {
            this.isRouteAddMumblCard = false
        }

        // get current user
        let user = firebase.auth().currentUser

        // change status on user
        firebase.auth().onAuthStateChanged((user) => {
            // if user is logged in save user object to local storage
            if(user) {
                this.user = user
            }
            // if use is not logged in set local data user to null
            else {
                this.user = null
            }
        })
    }
}
</script>

<style scoped lang="scss">
    @mixin base-only {
        @media only screen and (max-width: #{$w-base-max}) {
            @content;
        }
    }
    @mixin small {
        @media only screen and (min-width: #{$w-small-min}) {
            @content;
        }
    }
    @mixin small-only {
        @media only screen and (min-width: #{$w-small-min}) and (max-width:#{$w-small-max}) {
            @content;
        }
    }
    @mixin medium {
        @media only screen and (min-width: #{$w-medium-min}) {
            @content;
        }
    }
    @mixin medium-only {
        @media only screen and (min-width: #{$w-medium-min}) and (max-width:#{$w-medium-max}) {
            @content;
        }
    }
    @mixin large {
        @media only screen and (min-width: #{$w-large-min}) {
            @content;
        }
    }
    @mixin large-only {
        @media only screen and (min-width: #{$w-large-min}) and (max-width:#{$w-large-max}) {
            @content;
        }
    }
    @mixin xlarge {
        @media only screen and (min-width: #{$w-xlarge-min}) {
            @content;
        }
    }

    $c-white  : #ffffff;
    $c-black  : #000000;

    $w-base-max: 		480px;

    $w-small-min: 		481px;
    $w-small-max: 		960px;

    $w-medium-min: 		961px;
    $w-medium-max: 		1360px;

    $w-large-min: 		1361px;
    $w-large-max: 		1920px;

    $w-xlarge-min: 		1921px;

    .navbar {
        position: relative;
        margin-bottom: 80px;

        .nav-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .nav-links {
            margin: 0 auto;

            @include medium {
                margin: 0;
            }

            &__user {
                display: none;

                @include medium {
                    display: block;
                }
            }

            a,
            span {
                display: inline-block;
                padding: 1em;
            }
        }

        .btn-group {
            position: absolute;
            top: 15px;
            right: 2%;

            @include medium {
                top: 30px;
            }
        }

        .btn-floating {

            &.add {
                margin-left: 14px;
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue